import {
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import { useFormik } from "formik";
import * as yup from "yup";
import { useEnableCreateApiMutation } from "../../../services/bl-export/BLExportService";
import { useState } from "react";
import { Alert } from "@material-ui/lab";

const FormEnableApi = () => {
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [enableApi, { isLoading }] = useEnableCreateApiMutation();
  const schemaForm = yup.object().shape({
    cod_booking: yup.string().required("Campo Requerido"),
    tipo: yup.string().required("Campo Requerido"),
  });

  const { values, errors, touched, handleSubmit, setFieldValue, resetForm } =
    useFormik({
      initialValues: {
        cod_booking: "",
        tipo: "",
      },
      validationSchema: schemaForm,
      onSubmit(values) {
        setErrorMessage(null);
        setSuccessMessage(null);
        enableApi({
          cod_booking: values.cod_booking,
          tipo: values.tipo,
        })
          .unwrap()
          .then((data) => {
            resetForm();
            setSuccessMessage(data.message || "Success");
          })
          .catch((err) => {
            setErrorMessage(err);
          });
      },
    });

  const submit = () => handleSubmit();

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormLabel error={Boolean(errors.cod_booking && touched.cod_booking)}>
            Booking
          </FormLabel>
          <TextField
            value={values.cod_booking}
            fullWidth
            variant="outlined"
            placeholder="Booking"
            onChange={(val) => setFieldValue("cod_booking", val.target.value)}
            error={Boolean(errors.cod_booking && touched.cod_booking)}
            helperText={errors.cod_booking}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl
            component="fieldset"
            error={Boolean(errors.tipo && touched.tipo)}
          >
            <FormLabel component="legend">Tipo</FormLabel>
            <RadioGroup
              aria-label="tipo"
              name="tipo"
              value={values.tipo}
              onChange={(val) => {
                setFieldValue("tipo", val.target.value);
              }}
            >
              <FormControlLabel
                value="CREATE"
                control={<Radio color="primary" />}
                label="CREAR"
              />
              <FormControlLabel
                value="UPDATE"
                control={<Radio color="primary" />}
                label="ACTUALIZAR"
              />
            </RadioGroup>
            <FormHelperText>{errors.tipo}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          {successMessage != null ? (
            <Alert severity="success">{successMessage}</Alert>
          ) : null}
          {errorMessage != null ? (
            <Alert severity="error">{errorMessage}</Alert>
          ) : null}
        </Grid>
        <Grid item xs={12} />
        <Grid item xs={12}>
          <Button
            color="primary"
            variant="contained"
            fullWidth
            size="large"
            onClick={submit}
            disabled={isLoading}
          >
            Guardar
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default FormEnableApi;
